import { useTranslation } from "react-i18next";

import { TransactionType } from "./useTransactions";

const transactionTypeNameOverrideDictionary = {
  [TransactionType.ALLOWANCE_DELIVERY]:
    "transactions.label-type.allowance-delivery",
  [TransactionType.ACCUMULATION]:
    "transactions.label-type.accumulation-from-bag",
  [TransactionType.WITHDRAWAL]: "transactions.label-type.withdrawal",
  [TransactionType.REFUND]: null,
  [TransactionType.PURCHASE]: null,
};

const useTransactionName = ({
  type,
  merchantName,
}: {
  type: TransactionType;
  merchantName?: string;
}) => {
  const { t } = useTranslation();

  const overrideName = transactionTypeNameOverrideDictionary[type];
  if (overrideName) {
    return t(overrideName);
  }

  return merchantName;
};

export { useTransactionName };
